import { useSale } from "../../../contexts/SaleContext"
import React, { useEffect, useState } from "react"
import { DatePicker, TableColumnsType } from "antd"
import TableView from "../TableView"
import { useConfig } from "../../../contexts/ConfigContext"
import { useCompany } from "../../../contexts/CompanyContext"
import useAuth from "../../../hooks/useAuth"
import { useSales } from "../../../hooks/useSale"
import { saleStatus } from "../../../config/const"
import { getDateFilter, textNumberFormater } from "../../../utils"
import HeaderElements from "./HeaderElements";
import { useHistory } from "react-router-dom";

const { RangePicker } = DatePicker;

function ViewCreditNoteList() {
  const { sale, updateSale } = useSale()
  const { config } = useConfig()
  const { company } = useCompany()
  const history = useHistory()
  const [spinning, setSpinning] = useState(false)
  const [skeleton, setSkeleton] = useState(true)
  const { tokenData } = useAuth.useToken('authCsrfToken', config.session, config.key)

  // Pagination state
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(25)

  const { data: noteData, isLoading } = useSales(tokenData, {
    company: company.current.uid,
    status: saleStatus.COMPLETED,
    documentType: "CREDIT_NOTE",
    first: false,
    module: config.module,
    filter: getDateFilter(sale.datePickerFilter),
    page,
    hitsPerPage: pageSize
  },company.current.id)

  useEffect(() => {
    if (tokenData && noteData?.movementList) {
      updateSale({ billList: noteData.movementList })
      setSkeleton(false)
    }
  }, [tokenData, noteData])


  const handleClick = (data: any) => {
    history.push(`/bill-detail/${data.uid}`)
  }

  const tableColumns: TableColumnsType = [
    { title: "#", dataIndex: "register" },
    { title: "Registro", dataIndex: "document_number" },
    { title: "Fecha", dataIndex: "updated_at", render: (text) => new Date(text).toLocaleString() },
    { title: "Items", dataIndex: "items" },
    { title: "Cliente", dataIndex: "contact_name" },
    { title: "Vendedor", dataIndex: "created_by_user_name" },
    { title: "Total", dataIndex: "total_amount_net", render: (text) => <label className="numeric-values-data-table">{textNumberFormater(text)}</label> },
  ]

  const dataTable = sale.billList.map((el: any, i: number) => {
    el.register = i + 1
    el.key = i
    return el
  })

  const handlePageChange = (newPage: number, newPageSize?: number) => {
    setPage(newPage - 1) // Convert to 0-based for Algolia
    if (newPageSize && newPageSize !== pageSize) {
      setPageSize(newPageSize)
      setPage(0) // Reset to first page when page size changes
    }
  }

  const headerElement = () => <HeaderElements setSpinning={setSpinning} />
  return (
    <TableView
      title="Notas de Crédito"
      spinning={spinning || isLoading}
      skeleton={skeleton}
      tableColumns={tableColumns}
      dataTable={dataTable}
      onRow={(data: any) => ({ onClick: () => handleClick(data), style: { cursor: "pointer" } })}
      emptyMessage="No hay notas de crédito registradas"
      headerElement={headerElement}
      pagination={{
        current: page + 1,
        pageSize,
        total: noteData?.nbHits || 0,
        onChange: handlePageChange,
        showSizeChanger: false,
        showTotal: (total:number) => `Total ${total} notas`
      }}
    />
  )
}

export default ViewCreditNoteList
